import { MdSearch } from "react-icons/md";

// Controlled segmented Stocks / Crypto / Forex control + search input.
// All fetching lives in the parent (AddAssetsPanel) so it can drive both the
// default-category browse list and the search results (same as the old layout).
const CATEGORIES = ["Stocks", "Crypto", "Forex"];

export default function SegmentedAssetSearch({
  category,
  onCategoryChange,
  query,
  onQueryChange,
  loading,
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      {/* Segmented control */}
      <div className="inline-flex rounded-lg bg-gray-100 p-1">
        {CATEGORIES.map((cat) => {
          const active = cat === category;
          return (
            <button
              key={cat}
              type="button"
              onClick={() => onCategoryChange(cat)}
              className={`rounded-md px-4 py-1.5 text-sm transition-colors ${
                active
                  ? "bg-white font-semibold text-primaryColor shadow-sm"
                  : "text-secondary hover:text-primaryColor"
              }`}
            >
              {cat}
            </button>
          );
        })}
      </div>

      {/* Search field */}
      <div className="flex flex-1 items-center gap-2 rounded-lg border border-gray-200 bg-white px-3">
        <MdSearch size={18} className="shrink-0 text-tertiary" />
        <input
          type="text"
          className="w-full border-none bg-transparent py-2 text-sm focus:outline-none"
          placeholder="Search ticker or name"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
        />
        {loading && <span className="shrink-0 text-xs text-tertiary">Searching</span>}
      </div>
    </div>
  );
}
